
    import ServicesBlock from './ServicesBlock.vue';

    export default {
        name: 'ServicesSection',
        components: {
            ServicesBlock,
        },
    };
